// округлить до десятков
export const count = 70;
